// Zentrale Versionsstände der Rechtsdokumente (Single Source of Truth im Web-Client).
// Bei künftigen Änderungen NUR hier die Version(en) erhöhen; der Registrierungs- und
// Consent-Flow übermittelt automatisch die aktuelle Version an das Backend.
export const LEGAL_VERSIONS = {
  terms: "2026-08-01",   // Nutzungsbedingungen
  privacy: "2026-08-01", // Datenschutzerklärung
};
